module.exports = __webpack_public_path__ + "media/images/item-placeholder-ee007b2245fb443f98064b7396a9097d.jpg";